import React from 'react';

export function AnthropicIcon({ size = 25, disabled = false }: { size?: number; disabled?: boolean }) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 330.000000 330.000000"
      preserveAspectRatio="xMidYMid meet">
      <g
        transform="translate(0.000000,330.000000) scale(0.100000,-0.100000)"
        fill={disabled ? '#909296' : '#000000'}
        stroke="none">
        <path
          d="M775 2198 c-121 -304 -304 -763 -406 -1020 l-187 -468 227 0 226 0
24 63 c13 34 51 131 83 214 l60 153 424 0 425 0 16 -38 c9 -20 46 -116 83
-212 l68 -175 226 -3 c124 -1 226 0 226 3 0 2 -158 399 -351 882 -192 483
-374 939 -404 1013 l-54 135 -233 3 -233 2 -220 -552z m593 -324 c73 -187 132
-343 132 -347 0 -4 -124 -7 -276 -7 -217 0 -275 3 -271 13 3 6 51 129 107 272
55 143 115 297 133 342 17 45 35 79 38 75 3 -4 65 -160 137 -348z"
        />
        <path
          d="M1844 2733 c4 -10 186 -468 405 -1018 l399 -1000 221 -3 c122 -1 221
1 221 5 0 5 -182 463 -404 1018 l-404 1010 -222 3 c-208 2 -221 1 -216 -15z"
        />
      </g>
    </svg>
  );
}
